import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { DataTable, ExportButtons, MonthlyChart, FIN_COLS, Q } from "./shared";
import { Input } from "../ui/input";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";
import { Loader2, Search } from "lucide-react";
import { toast } from "sonner";

// Pestaña genérica: ranking (clientes o productos) + detalle al tocar una fila.
export const RankingTab = ({ kind, params }) => {
  const isClient = kind === "clients";
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);
  const [det, setDet] = useState(null);

  useEffect(() => {
    let live = true;
    setRows(null);
    api.get(`/analytics/${kind}`, { params }).then((r) => { if (live) setRows(r.data.rows); }).catch((e) => live && toast.error(formatApiError(e.response?.data?.detail)));
    return () => { live = false; };
  }, [kind, params]);
  useEffect(() => {
    let live = true;
    setDet(null);
    if (!sel) { return undefined; }
    api.get(`/analytics/${isClient ? "client" : "product"}-detail`, { params: { ...params, key: sel.key } }).then((r) => { if (live) setDet(r.data); }).catch(() => {});
    return () => { live = false; };
  }, [sel, params, isClient]);

  const cols = isClient
    ? [{ key: "name", label: "Cliente" }, { key: "docs", label: "Docs", num: true }, ...FIN_COLS, { key: "ticket", label: "Ticket", money: true }, { key: "share", label: "% part.", pct: true }]
    : [{ key: "code", label: "Código", cls: "font-mono text-xs" }, { key: "description", label: "Producto" }, { key: "qty", label: "Cant.", num: true }, { key: "clients", label: "Clientes", num: true }, ...FIN_COLS];
  const detCols = isClient
    ? [{ key: "code", label: "Código", cls: "font-mono text-xs" }, { key: "description", label: "Producto" }, { key: "qty", label: "Cant.", num: true }, ...FIN_COLS]
    : [{ key: "name", label: "Cliente" }, { key: "qty", label: "Cant.", num: true }, { key: "last", label: "Última" }, ...FIN_COLS];
  const t = q.trim().toLowerCase();
  const filtered = (rows || []).filter((r) => !t || `${r.name || ""} ${r.code || ""} ${r.description || ""}`.toLowerCase().includes(t));
  const selName = sel ? (sel.name || `${sel.code ? sel.code + " · " : ""}${sel.description}`) : "";

  return (
    <div className="space-y-3" data-testid={`analytics-${kind}`}>
      <div className="flex flex-wrap items-center gap-2 justify-between">
        <div className="relative w-full sm:w-72"><Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input className="pl-8 rounded-sm h-9" placeholder={isClient ? "Buscar cliente..." : "Buscar producto o código..."} value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${kind}-search`} /></div>
        <ExportButtons tab={kind} params={params} />
      </div>
      <p className="text-xs text-muted-foreground">Toca una fila para ver {isClient ? "qué productos compra ese cliente" : "qué clientes compran ese producto"}.</p>
      {rows === null ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
        : <DataTable cols={cols} rows={filtered} onRow={setSel} testid={`${kind}-table`} />}
      <Sheet open={!!sel} onOpenChange={(o) => !o && setSel(null)}>
        <SheetContent side="right" className="w-full sm:max-w-3xl overflow-y-auto" data-testid={`${kind}-detail`}>
          <SheetHeader><SheetTitle>{selName}</SheetTitle></SheetHeader>
          {sel && <p className="text-sm text-muted-foreground mt-1">Venta {Q(sel.venta)} · Utilidad {Q(sel.utilidad)} ({sel.margen}%)</p>}
          {!det || !sel ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div> : (
            <div className="space-y-4 mt-4">
              <div className="flex justify-end"><ExportButtons tab={isClient ? "client" : "product"} testid={`${kind}-detail`} params={{ ...params, key: sel.key, name: selName }} /></div>
              {isClient && <MonthlyChart data={det.monthly} height={220} testid="client-detail-chart" />}
              <h4 className="text-xs font-bold uppercase tracking-widest text-muted-foreground">{isClient ? "Productos que más compra" : "Clientes que lo compran"}</h4>
              <DataTable cols={detCols} rows={isClient ? det.products : det.rows} testid={`${kind}-detail-table`} />
            </div>)}
        </SheetContent>
      </Sheet>
    </div>
  );
};
